import "bootstrap/dist/css/bootstrap.min.css";
import * as HERBUI from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import { budgetPdfs } from "../components/Functions";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization } from "../Api/CommonAjaxUtils";
import { AWS_DOWNLOAD_URL } from "../Api/APIURLS";

export default function BudgetRelatedPdfDetails() {


    // Fetch AWS PDF dynamically
    const getS3UrlData = async (url) => {
        const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
            AWS_DOWNLOAD_URL + url
        );
        if (resp) {
            // return resp;
            window.open(resp, "_blank");
        }
    }



    return (
        <>
            <Header />

            <HERBUI.Container style={{ marginTop: "80px" }}>
                <HERBUI.Row>
                    <HERBUI.Col className="page-titlespacing">
                        <div className="inner-herbpage-service-title1">
                            <h1>Budget Information</h1>
                        </div>
                    </HERBUI.Col>
                </HERBUI.Row>
            </HERBUI.Container>

            <HERBUI.Container className="bg-white">
                <HERBUI.Row className="p-4">
                    <HERBUI.Accordion defaultActiveKey="0">
                        {budgetPdfs.map((sec, idx) => (
                            <HERBUI.Accordion.Item eventKey={String(idx)} key={idx}>
                                <HERBUI.Accordion.Header>
                                    {sec.title}{" "}
                                    {sec.items.some(i => i.isNew) && (
                                        <img src="../img/gif_new.gif" alt="new" />
                                    )}
                                </HERBUI.Accordion.Header>

                                <HERBUI.Accordion.Body>
                                    <HERBUI.Row>
                                        {sec.items.map((item, k) => (
                                            <HERBUI.Col
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={3}
                                                xl={3}
                                                xxl={3}
                                                className="mt-2"
                                                key={k}
                                            >
                                                <HERBUI.Card style={{ minHeight: "255px" }}>
                                                    <HERBUI.Card.Body>
                                                        <HERBUI.Card.Title className="text-primary mb-3">
                                                            {item.title}{" "}
                                                            {item.isNew && (
                                                                <img src="../img/gif_new.gif" alt="new" />
                                                            )}
                                                        </HERBUI.Card.Title>

                                                        <HERBUI.Card.Text>
                                                            <a
                                                                // href={item.pdf}
                                                                onClick={() => getS3UrlData(item?.downloadUrl)}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="text-black"
                                                                style={{ cursor: "pointer" }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                        getS3UrlData(item?.downloadUrl);
                                                                    }
                                                                }}
                                                            >
                                                                {item.desc || item.title}
                                                            </a>
                                                        </HERBUI.Card.Text>
                                                    </HERBUI.Card.Body>
                                                </HERBUI.Card>
                                            </HERBUI.Col>
                                        ))}
                                    </HERBUI.Row>
                                </HERBUI.Accordion.Body>
                            </HERBUI.Accordion.Item>
                        ))}
                    </HERBUI.Accordion>
                </HERBUI.Row>
            </HERBUI.Container>

            <Footer />
        </>
    );
}
